import type { ReactNode } from "react";
import { cx } from "@frontend/components/ui";

export function Section({
  id,
  children,
  className,
  tight,
  /** Marks a dark band so the floating header can invert over it. */
  "data-nav-dark": navDark,
}: {
  id?: string;
  children: ReactNode;
  className?: string;
  tight?: boolean;
  "data-nav-dark"?: boolean;
}) {
  return (
    <section id={id} className={cx("scroll-mt-24", className)} data-nav-dark={navDark}>
      <div
        className={cx(
          "mx-auto w-full max-w-6xl px-4",
          tight ? "py-12 sm:py-14" : "py-16 sm:py-20 lg:py-24",
        )}
      >
        {children}
      </div>
    </section>
  );
}

export function Eyebrow({ children }: { children: ReactNode }) {
  return <p className="mkt-kicker">{children}</p>;
}

export function SectionIntro({
  eyebrow,
  title,
  body,
  className,
}: {
  eyebrow: string;
  title: string;
  body?: string;
  className?: string;
}) {
  return (
    <div className={cx("max-w-2xl", className)}>
      <Eyebrow>{eyebrow}</Eyebrow>
      <h2 className="mkt-display mt-4 text-4xl leading-[1.05] text-balance sm:text-5xl">{title}</h2>
      {body ? <p className="mt-4 text-lg leading-relaxed text-ink/55 text-pretty">{body}</p> : null}
    </div>
  );
}
